import {
  Button,
  ModalBody,
  ModalContent,
  ModalFooter,
  Spinner,
} from '@nextui-org/react'
import { FC, useState } from 'react'
import { BaseModal, BaseModalHeader, BaseDivider } from '../common/Modal'
import { emptyTank } from '../../api/tank/tank.service'
import { reloadGroupsWithSchoolsAndTanks } from '../../utils/loadStorage'
import type { SelectedTankArray } from '@/types/view'

export interface ConfirmEmptyTankProps {
  isOpen: boolean
  onOpenChange: () => void
  isBack: () => void
  selectedTank: SelectedTankArray[0] | null
  onSuccess: () => void
}

export const ConfirmEmptyTank: FC<ConfirmEmptyTankProps> = ({
  isOpen,
  onOpenChange,
  isBack,
  selectedTank,
  onSuccess,
}) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleConfirmEmpty = async (onClose: () => void) => {
    if (!selectedTank) return

    setIsLoading(true)
    try {
      await emptyTank({
        tankId: selectedTank.tankId,
        reason: 'Manual empty via home screen',
      })

      await reloadGroupsWithSchoolsAndTanks()
      onSuccess()
      onClose()
    } catch (error) {
      console.error('Failed to empty tank:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <BaseModal isOpen={isOpen} onOpenChange={onOpenChange} size={'md'} isDismissable={!isLoading}>
      <ModalContent className="overflow-x-hidden">
        {(onClose) => (
          <>
            <BaseModalHeader
              title="Confirm Empty Tank"
              description="Please confirm you want to empty this tank"
            />
            <ModalBody className="gap-1 min-h-[6rem] pl-6 sm:pl-10 pr-6 sm:pr-10 overflow-x-hidden overflow-y-auto">
              <BaseDivider />
              <div className="flex flex-col items-center py-4">
                <p className="text-center text-tdplindigo font-semibold text-lg mb-2">
                  Empty Tank: {selectedTank?.tankName}
                </p>
                <p className="text-center text-tdpldarkgrey text-sm">
                  This action will mark the tank as empty.
                  The tank will be moved to the "Empty Tanks" section.
                </p>
              </div>
            </ModalBody>
            <ModalFooter className="pb-6 sm:pb-8 pl-6 sm:pl-10 pr-6 sm:pr-10">
              <div className="flex gap-3 justify-end w-full">
                <Button
                  variant="light"
                  className="font-bold text-tdplindigo border border-tdplindigo"
                  onPress={() => {
                    onClose()
                    setTimeout(() => {
                      isBack()
                    }, 50)
                  }}
                  isDisabled={isLoading}
                >
                  Back
                </Button>
                <Button
                  className="font-bold text-white w-[8rem] mr-0 bg-tdplplum"
                  onPress={() => handleConfirmEmpty(onClose)}
                  isDisabled={isLoading}
                >
                  {isLoading ? (
                    <Spinner size="sm" color="white" />
                  ) : (
                    'Confirm'
                  )}
                </Button>
              </div>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </BaseModal>
  )
}
